import React, { useRef } from "react";
import styled from "styled-components";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import { submitContactForm } from './api/contact';
import SimplePopup from "./SimplePopup";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.18);
  z-index: 1100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Popup = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  width: 90vw;
  max-width: 600px;
  padding: 32px 30px 24px 30px;
  position: relative;
  font-family: 'Segoe UI', sans-serif;
  color: #111;
  display: flex;
  flex-direction: column;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 18px;
  right: 18px;
  background: none;
  border: none;
  color: #b30000;
  font-size: 1.6rem;
  cursor: pointer;
  &:hover {
    color: #660000;
  }
`;

const Title = styled.h2`
  font-weight: 900;
  font-size: 2.1rem;
  margin-bottom: 24px;
  text-align: center;
  color: #b30000; /* Match Submit button color */
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  align-items: center;
`;

const Row = styled.div`
  display: flex;
  gap: 18px;
  width: 100%;
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const Input = styled.input`
  flex: 1;
  font-size: 1em;
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 12px;
  outline: none;
  background: #faf9f8;
  &:focus {
    border-color: #b30000;
    box-shadow: 0 0 6px #ffc0cb;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  font-size: 1em;
  padding: 14px 14px;
  border-radius: 12px;
  border: 1px solid #ccc;
  resize: vertical;
  min-height: 110px;
  outline: none;
  background: #faf9f8;
  &:focus {
    border-color: #b30000;
    box-shadow: 0 0 6px #ffc0cb;
  }
`;

const SubmitButton = styled.button`
  background-color: #b30000;
  border: none;
  padding: 12px 35px;
  border-radius: 12px;
  color: white;
  font-weight: 700;
  font-size: 1.1em;
  cursor: pointer;
  box-shadow: 0 0 6px #ffc0cb;
  transition: background-color 0.2s ease;
  margin-top: 10px;
  align-self: center;
  &:hover {
    background-color: #990000;
  }
`;

function ContactUs({ onClose }) {
  const formRef = useRef();
  const [popup, setPopup] = React.useState({ open: false, message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formRef.current.checkValidity()) {
      const formData = new FormData(formRef.current);
      const data = {
        name: formData.get("name"),
        phone: formData.get("phone"),
        email: formData.get("email"),
        message: formData.get("comment"),
      };
      try {
        await axios.post(`${BASE_URL}/api/contact/`, data);
        setPopup({ open: true, message: "Thank you for contacting us! We will get back to you soon." });
        formRef.current.reset();
        // onClose(); // Optionally close after popup
      } catch (error) {
        setPopup({ open: true, message: "There was an error submitting the form. Please try again later." });
      }
    } else {
      formRef.current.reportValidity();
    }
  };

  return (
    <Overlay>
      <Popup role="dialog" aria-modal="true" aria-labelledby="contact-us-title">
        <CloseButton aria-label="Close contact form" onClick={onClose}>
          <FaTimes />
        </CloseButton>
        <Title id="contact-us-title">Reach out anytime!</Title>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Row>
            <Input type="text" name="name" placeholder="Name" required />
            <Input type="email" name="email" placeholder="Email" required />
          </Row>
          <Row>
            <Input type="tel" name="phone" placeholder="Phone" required />
          </Row>
          <TextArea name="comment" placeholder="Message" required />
          <SubmitButton type="submit">Submit</SubmitButton>
        </Form>
      </Popup>
      {popup.open && (
        <SimplePopup
          message={popup.message}
          onClose={() => {
            setPopup({ open: false, message: "" });
            if (popup.message.startsWith("Thank you")) onClose();
          }}
        />
      )}
    </Overlay>
  );
}

export default ContactUs;
